import { useCallback, useMemo, useRef } from 'react';
import type { IMcToast } from '@maersk-global/mds-components-core-toast';

import type { ToastContextState } from '../contexts/ToastContext';
import ToastContext from '../contexts/ToastContext';

interface ToastProviderProps {
  children: React.ReactNode;
}

const ToastProvider = ({ children }: ToastProviderProps) => {
  const toastRootElement = useRef<HTMLDivElement | null>(null);

  const showToast = useCallback(
    (message: string, type: IMcToast['appearance']) => {
      if (toastRootElement.current) {
        toastRootElement.current.innerHTML = `
        <mc-toast position="top-right" appearance="${type}" open>
          <mc-notification appearance="${type}">
            ${message}
          </mc-notification>
        </mc-toast>
      `;
      }
    },
    []
  );

  const contextValue: ToastContextState = useMemo(
    () => ({
      showToast,
    }),
    [showToast]
  );

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
      <div ref={toastRootElement} id="toast-root" />
    </ToastContext.Provider>
  );
};

export default ToastProvider;
